@if (node() && formGroup()) {
<div class="prototype-panel">
    <form class="prototype-form" [formGroup]="formGroup()!" (ngSubmit)="onSubmit()">
        <div class="header">
            <ul class="tabs">
                @for (tab of tabs; track tab.caption) {
                <li class="tab" [hidden]="tab.hidden"><a class="tab-link" (click)="onClick(tab)"
                        [ngClass]="{'active': tabSelected == tab}">{{tab.caption}}</a></li>
                }
            </ul>
        </div>
        <div cdkDropListGroup class="body">
            <div class="row key" [hidden]="tabSelected != tabPrototype">
                <app-graphql-checker [formGroup]="formGroup()!" [model]="graphqlType" [validate]="validate" [meta]="metaGraphql" [readonly]="node()!._system">
                </app-graphql-checker>
            </div>
            <div class="row prototype" [formArray]="formArray" [hidden]="tabSelected != tabPrototype">
                @for (tag of tags | keyvalue; track tag.key) {
                <app-expansion [model]="tag.value" [status]="model().custome[tag.key]" [meta]="tag.value.meta" [focus]="focus" (tagChange)="onTag($event)">
                    <div class="drop-container" cdkDropList [cdkDropListData]="tag.value" (cdkDropListDropped)="onDrop($event)">
                        @for (item of tag.value.items; track item.id; let i = $index) {
                        <div cdkDrag cdkDragLockAxis="y" cdkDragBoundary=".body" class="prototype-panel-drag">
                            <app-field [formGroup]="item.group" [tagControl]="item.control" [id]="item.id" [field]="item.field" (delete)="onDelete(item.field)">
                                @if(!item.field.value.readonly) {
                                <div class="drag-handle" cdkDragHandle>
                                    <mat-icon>push_pin</mat-icon>
                                </div>
                                }
                            </app-field>
                        </div>
                        }
                    </div>
                    @if(!tag.key.startsWith('_') && !(focus === tag.value)) {
                    <button type="button" class="button" (click)="onAddField(tag.value.tag)">
                        <mat-icon class="small-icon">add_box</mat-icon>
                    </button>
                    }
                </app-expansion>
                }
            </div>
            <div class="row meta" [hidden]="tabSelected != tabMeta">
                <app-meta [formGroup]="formGroup()!" [model]="node()!.meta"></app-meta>
            </div>
        </div>
        <div class="footer">
            <div class="row">
                <button type="button" class="button button-big" [hidden]="tabSelected != tabPrototype" (click)="onAddTag()">
                    <mat-icon class="regular-icon">add_circle</mat-icon>
                </button>
                <button type="submit" class="button button-big" [disabled]="disabled || !!focus">
                    <mat-icon class="regular-icon">save</mat-icon>
                </button>
            </div>
        </div>
    </form>
</div>
}
